import { EditKeyContactsModal } from "./EditKeyContactsModal";

export default EditKeyContactsModal;